import React, { useState } from "react";
import { X, ShieldOff, ShieldCheck } from "lucide-react";

const BlockReasonModal = ({ isBlocking, userName, onConfirm, onCancel }) => {
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    if (isBlocking && !reason.trim()) return;
    onConfirm(reason.trim());
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md mx-4 p-6">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            {isBlocking ? (
              <ShieldOff size={20} className="text-red-500" />
            ) : (
              <ShieldCheck size={20} className="text-green-500" />
            )}
            <h2 className="font-popinsSemiBold text-lg">
              {isBlocking ? "Block User" : "Unblock User"}
            </h2>
          </div>
          <button onClick={onCancel} className="text-gray-400 hover:text-gray-600">
            <X size={20} />
          </button>
        </div>

        <p className="text-sm font-popinsRegular text-gray-600 mb-4">
          {isBlocking ? (
            <>
              You are about to block <span className="font-popinsSemiBold text-gray-900">{userName}</span>.
              They will not be able to log in. Please provide a reason.
            </>
          ) : (
            <>
              You are about to unblock <span className="font-popinsSemiBold text-gray-900">{userName}</span>.
              They will be able to log in again.
            </>
          )}
        </p>

        {isBlocking && (
          <div className="mb-4">
            <label className="block text-xs font-popinsSemiBold text-gray-600 uppercase tracking-wider mb-1">
              Reason <span className="text-red-500">*</span>
            </label>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Enter the reason for blocking this user…"
              rows={3}
              className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm font-popinsRegular focus:outline-none focus:border-themeColor resize-none"
            />
          </div>
        )}

        <div className="flex gap-3 justify-end">
          <button
            onClick={onCancel}
            className="px-4 py-2 text-sm font-popinsMedium text-gray-600 border border-gray-200 rounded-lg hover:bg-gray-50 transition"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            disabled={isBlocking && !reason.trim()}
            className={`px-4 py-2 text-sm font-popinsMedium text-white rounded-lg transition disabled:opacity-40 disabled:cursor-not-allowed ${
              isBlocking
                ? "bg-red-500 hover:bg-red-600"
                : "bg-green-500 hover:bg-green-600"
            }`}
          >
            {isBlocking ? "Block User" : "Unblock User"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlockReasonModal;
